/**
 * App shell — the three layouts and the two media queries that pick them.
 *
 * ⛔ KEEP THIS FILE IMPORT-FREE (the node-tests execute it verbatim).
 *
 *   desktop ≥ 1024px   sidebar 1b (wide 240px / icons 64px) + top bar 1d
 *   tablet  768–1023   1g: the rail (short labels under icons, 44px targets)
 *   phone   < 768px    1h: slim bar + bottom tab bar + drawer
 *
 * 1d is ~600px narrower than the classic header, so 1280px laptops get the full bar; 1024 is the
 * iPad-landscape edge; 768 is the classic header's phone edge. src/components/AppShell/_shell.scss
 * must use exactly these values in its media blocks — cypress/node-tests/nav-breakpoints.test.js.
 */

export const DESKTOP_QUERY = '(min-width: 1024px)';
export const PHONE_QUERY = '(max-width: 767.98px)';

/** From the two queries' `matches`. Desktop wins if both somehow match. */
export function shellModeFor(desktop, phone) {
  if (desktop === true) return 'desktop';
  if (phone === true) return 'phone';
  return 'tablet';
}
